import React from 'react'
import {
    Flex,
    Box,
    Spacer,
    Grid
} from "@chakra-ui/react";
import WelcomeEmail from '../common/WelcomeEmail'; 


function Header(props) {
    return (
        <Grid pl={3} pr={3} pb={2}>
            <Box boxShadow="md" p="2" rounded="md" bg="white" h="70px">
              <Flex>
                    {props.children}
                <Spacer />
                <WelcomeEmail />
              </Flex>
            </Box>
          </Grid>
    )
}

export default Header
